import { Component, DoCheck, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RootScope } from '@encomply-core/services/rootscope/rootscope.service';
import { TaxillaApiService } from '@encomply-core/services/taxillaapi/taxillaapi.service';
import { Utils } from '@encomply-core/services/utils/utils.service';
import { Subscription } from 'rxjs';
import { Address, CommonUtilsService } from 'taxilla-library';

import { ModifiedErrorStateMatcher } from '../../../extensions/errorstatematcher/errorstatematcher';

@Component({
    selector: 'countries',
    templateUrl: './countries.html',
    standalone: false,
})
export class CountriesComponent implements OnInit, DoCheck, OnChanges, OnDestroy {
    @Input() data: Address;
    @Input() tabindex: string;
    @Input() id: string;
    @Input() errors: string[] = [];
    @Input() required = false;
    @Input() disabled = false;
    @Input() registerAddressCountry: any;
    @Input() blockEvent = false;

    @Output() countryNameChanged = new EventEmitter<string>();

    matcher = new ModifiedErrorStateMatcher();
    control = new FormControl<string | null>({ value: '', disabled: this.disabled });
    valueSubscription: Subscription;
    countries: { id: number; name: string }[] = [];
    country = '';

    constructor(public R: RootScope, public _utils: Utils, public _taxilla: TaxillaApiService, private _commonUtils: CommonUtilsService) {}

    ngDoCheck() {
        const controlErrors = this.control.getError('errors');

        // No change needed if both are undefined
        if (!this.errors && !controlErrors) return;

        // Clear control errors if local errors are empty or undefined
        if ((!this.errors || this.errors.length === 0) && controlErrors) {
            this.control.setErrors(undefined);
            return;
        }

        // Update control errors if they differ
        if (this.errors?.length && JSON.stringify(this.errors) !== JSON.stringify(controlErrors)) {
            this.control.setErrors({ errors: this.errors });
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data && changes.data.currentValue?.country !== this.control.value) {
            this.control.setValue(changes.data.currentValue.country);
        }
        if (changes.disabled) this.control[changes.disabled.currentValue ? 'disable' : 'enable']();
        if (changes.registerAddressCountry && this.disabled) this.control.setValue(this.data.country);
    }

    getCountry(): void {
        const cached = this._commonUtils.getFromStorage('countries');
        if (cached) {
            this.countries = cached;
            this.R.countries = cached;
            return;
        }

        this._taxilla.common.getCountries({
            successCallback: response => {
                const countries = (response || []).map(c => ({ ...c, name: this._utils.transformText(c.name) }));
                this.countries = countries;
                this.R.countries = countries;
                this._commonUtils.setInStorage('countries', countries);
            },
            failureCallback: () => {},
        });
    }

    countryChanged(newValue: string | null): void {
        this.errors = [];

        if (!newValue) {
            ['country', 'countryName', 'state', 'city', 'zipCode'].forEach(k => delete this.data[k]);
        } else {
            this.data.state = '';
            this.data.city = '';
            this.data.zipCode = '';
            this.data.country = newValue;
            this.data.countryName = this.countries.find(c => c.id === +newValue)?.name || '';
        }

        this.countryNameChanged.emit(this.data.country);
    }

    ngOnInit(): void {
        this.valueSubscription = this.control.valueChanges.subscribe(value => {
            if (!this.blockEvent) this.countryChanged(value);
        });
        this.getCountry();
    }

    ngOnDestroy(): void {
        this.valueSubscription?.unsubscribe();
    }
}
